import classNames from 'classnames';
import React from 'react';
import { useConfig } from '../../../contexts/config-context';
import { ForcedState, useForcedState } from '../../../contexts/forced-state-context';
import { getColor } from '../utils/drawer';
import { SignatureDrawer } from './signature-drawer';
import styles from './signature-drawer-wut.module.scss';
export const SignatureDrawerWUT = ({ hasError, required, ...props })=>{
    const { compId } = useConfig();
    const inputColor = getColor(compId, '--wix-forms-formInputValueColor');
    const penColor = inputColor && `rgb(${inputColor})`;
    const forcedState = useForcedState();
    const forcedError = forcedState.includes(ForcedState.INPUT_FIELDS_ERROR);
    const forcedHover = forcedState.includes(ForcedState.INPUT_FIELDS_HOVER);
    return /*#__PURE__*/ React.createElement(SignatureDrawer, {
        ...props,
        className: classNames(styles.container, {
            [styles.error]: hasError || forcedError,
            [styles.hover]: forcedHover
        }),
        penColor: penColor
    });
};

//# sourceMappingURL=signature-drawer-wut.js.map